/**
 * DeleteModal Component
 * Reusable delete confirmation modal
 */

import React from "react";
import { Modal, Button, CircularProgress } from "@mui/material";
import "./DeleteModal.css";
import "../../Constants/constants.css";
import "../../Constants/config.css";

interface DeleteModalProps {
  open: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  message?: string;
  title?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  open,
  isDeleting,
  onClose,
  onDelete,
  message = "Are you sure you want to delete this item?",
  title = "DELETE CONFIRMATION",
}) => {
  return (
    <Modal
      open={open}
      onClose={() => !isDeleting && onClose()}
      aria-labelledby="delete-confirmation-modal-title"
      aria-describedby="delete-confirmation-modal-description"
    >
      <div className="delete-modal-popup">
        <h6 className="delete-modal-h6">{title}</h6>
        <hr className="mb-0" />
        <div className="delete-modal-body">
          <div style={{ marginBottom: "20px" }}>
            <div className="delete-modal-text">
              {isDeleting ? "Deleting, please wait..." : message}
            </div>
            {isDeleting && (
              <div className="delete-modal-loader">
                <CircularProgress size={24} style={{ color: "var(--loader-color)" }} />
              </div>
            )}
          </div>
        </div>
        <div className="delete-modal-buttons">
          <Button
            disableElevation
            variant="contained"
            className="review-btn-filled"
            onClick={onDelete}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
          <Button
            disableElevation
            variant="contained"
            className="cancel-btn-filled"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
